// Barra fixa de compra (<sticky-buy>): aparece quando o botão de compra
// da coluna sai da tela e some quando ele volta, que é o que a anotação
// do desenho pede.
//
// O estado é o atributo hidden, declarativo: nada fica meio aberto se a
// rolagem for interrompida. Sem JS a barra nunca aparece, e a página
// continua inteira, porque o botão de verdade está logo acima.
//
// Três jeitos de comprar, decididos no Liquid e ligados aqui:
// - sem variantes, o botão envia o formulário de compra (atributo form)
//   e o cart.js faz o resto, como no botão da coluna;
// - com variantes no celular, "Escolher tamanho" rola até o seletor e o
//   acende: a primeira variante vem pré-marcada, e adicionar direto
//   mandaria um tamanho que ninguém escolheu. Depois que a pessoa mexe
//   no seletor, o botão de adicionar assume;
// - com variantes no desktop, a lista de variantes na própria barra troca
//   a variante pela mesma rota do seletor, e a barra volta renderizada
//   com preço e botão da variante nova.

class StickyBuy extends HTMLElement {
  connectedCallback() {
    this.page = this.closest('product-page');
    this.target = document.querySelector('[data-buy]');
    if (!this.target) return;

    this.listeners = new AbortController();
    const { signal } = this.listeners;

    // Some enquanto o botão de verdade estiver à vista. Sem margem: o
    // ponto de virada é o botão sair da tela, não chegar perto.
    this.observer = new IntersectionObserver(
      ([entry]) => this.toggleAttribute('hidden', entry.isIntersecting),
      { threshold: 0 }
    );
    this.observer.observe(this.target);

    this.addEventListener('click', this.handleClick, { signal });
    this.addEventListener('change', this.handleChange, { signal });
    // A barra é trocada inteira a cada variante, então quem lembra que a
    // pessoa já escolheu é a página, que fica.
    document.addEventListener('change', this.rememberChoice, { signal });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.listeners?.abort();
  }

  handleClick = (event) => {
    const link = event.target.closest('[data-sticky-choose]');
    if (!link) return;
    const picker = document.getElementById(link.getAttribute('href').slice(1));
    if (!picker) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    picker.scrollIntoView({ block: 'center', behavior: reduce ? 'instant' : 'smooth' });
    picker.setAttribute('data-highlight', '');
    picker.addEventListener('animationend', () => picker.removeAttribute('data-highlight'), { once: true });
    picker.querySelector('.variant-picker__input:checked')?.focus({ preventScroll: true });
  };

  handleChange = (event) => {
    const select = event.target.closest('[data-sticky-select]');
    if (!select || !this.page?.selectVariant) return;
    this.page.selectVariant(select.value);
  };

  rememberChoice = (event) => {
    if (!event.target.closest('.variant-picker__input, [data-sticky-select]')) return;
    this.page?.setAttribute('data-variant-chosen', '');
  };
}

if (!customElements.get('sticky-buy')) {
  customElements.define('sticky-buy', StickyBuy);
}
